import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=05c8857f&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"
import style0 from "./Reset.vue?vue&type=style&index=0&id=05c8857f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8857f",
  null
  
)

export default component.exports